import { DoqType } from '@ardoq/doq';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { emptyView$ } from 'views/streams/emptyView$';
import { NoConnectedComponentsDoq } from '@ardoq/graph';
import { type I18nLocale } from '@ardoq/i18n';
import { NoDataAvailableDoq } from 'tabview/graphViews/emptyStates/NoDataAvailableDoq';
import { NoDataWithFiltersDoq } from 'tabview/graphViews/emptyStates/NoDataWithFiltersDoq';
import { NoSelectedContextComponentDoq } from 'tabview/graphViews/emptyStates/NoSelectedContextComponentDoq';
import { onViewSettingsUpdate } from 'tabview/onViewSettingsUpdate';
import { CanvasEmptyStates } from './CanvasEmptyStates';
type EmptyStateProps = {
  noConnectedComponents: boolean;
  hasActiveFilter: boolean;
  noContext: boolean;
  isPresentationMode: boolean;
  isWorkspaceEmpty: boolean;
  isCanvasEmpty: boolean;
  isCanvasNoSelection: boolean;
  i18nLocale: I18nLocale;
};

const EmptyStateBase = ({
  hasActiveFilter,
  noConnectedComponents,
  noContext,
  isPresentationMode,
  isWorkspaceEmpty,
  isCanvasEmpty,
  isCanvasNoSelection,
  i18nLocale,
}: EmptyStateProps) => {
  if (isCanvasEmpty || isCanvasNoSelection) {
    return (
      <CanvasEmptyStates
        isCanvasEmpty={isCanvasEmpty}
        isCanvasNoSelection={isCanvasNoSelection}
      />
    );
  }
  if (isWorkspaceEmpty) {
    return (
      <NoDataAvailableDoq
        doqType={DoqType.BLOCK_DIAGRAM_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }
  if (noContext) {
    return (
      <NoSelectedContextComponentDoq doqType={DoqType.BLOCK_DIAGRAM_ERROR} />
    );
  }

  if (hasActiveFilter) {
    return (
      <NoDataWithFiltersDoq
        doqType={DoqType.BLOCK_DIAGRAM_ERROR}
        includeActions={!isPresentationMode}
      />
    );
  }

  if (noConnectedComponents) {
    return (
      <NoConnectedComponentsDoq
        doqType={DoqType.BLOCK_DIAGRAM_ERROR}
        viewId={ViewIds.BLOCK_DIAGRAM}
        includeActions={!isPresentationMode}
        onViewSettingsUpdate={onViewSettingsUpdate}
        i18nLocale={i18nLocale}
      />
    );
  }

  return null;
};

export const EmptyState = connect(EmptyStateBase, emptyView$);
